<div class="simple-login">
  <span>{{ "Login with the password from the team that you'd like to join." | translate }}</span>
  <andor-text-input
    [control]="password"
    autocomplete="password"
    type="password"
    (actionClicked)="appService.login($event)"
    toolTipMsg="{{ 'The password to join a team and unlock advanced permissions.' | translate }}"
    errorMsg="{{ 'Password may not be empty and contains at least 6 characters.' | translate }}"
    label="{{ 'Team Password' | translate }}"></andor-text-input>
  <andor-button
    [disabled]="
      appService.cooldown.remaining('roleLogin') > 0 ||
      appService.authenticationState() === 'loading'
    "
    (click)="appService.login(password.value ?? '')">
    Login
  </andor-button>
  @if (appService.cooldown.remaining('roleLogin')) {
    <p role="status">
      {{
        'Please wait [seconds] seconds before trying again.'
          | translate: { seconds: appService.cooldown.remaining('roleLogin') }
      }}
    </p>
  }
  <andor-forgot-password></andor-forgot-password>
</div>
